export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

/**
 * Get default profile image based on user gender
 * @param gender - User gender (homme, femme, boy, girl, male, female, etc.)
 * @returns Path to default profile image
 */
export const getDefaultProfileImage = (gender?: string): string => {
  if (!gender) {
    // Default to male profile if gender is not specified
    return toAbsoluteUrl('/media/logos/profile2.jpg')
  }

  const normalizedGender = gender.toLowerCase().trim()

  // Check for female/girl/femme
  if (
    normalizedGender === 'femme' ||
    normalizedGender === 'girl' ||
    normalizedGender === 'female' ||
    normalizedGender === 'f' ||
    normalizedGender === 'fille'
  ) {
    return toAbsoluteUrl('/media/logos/profile1.png')
  }

  // Default to male/boy/homme
  return toAbsoluteUrl('/media/logos/profile2.jpg')
}